module.exports = __webpack_public_path__ + "media/images/flags/4x3/eng-8ef6bd9e1e42b574cfd2313413d6fdc9.svg";